(() => {
  const hosts = document.querySelectorAll('[data-cc-follow-lazy]');
  const activate = host => {
    const template = host.querySelector('template');
    if (template) host.replaceChildren(template.content.cloneNode(true));
  };
  if (!('IntersectionObserver' in window)) { hosts.forEach(activate); return; }
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);
      activate(entry.target);
    });
  }, { rootMargin: '600px' });
  hosts.forEach(host => observer.observe(host));
})();
